export const GET_CONFIG = "GET_CONFIG";

export const GET_GAMES = 'GET_GAMES';
export const GET_GAME = 'GET_GAME';
export const GET_SERVERS = 'GET_SERVERS';

export const GET_ERRORS = 'GET_ERRORS';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';

export const POSTING_LOADING = 'POSTING_LOADING';
export const CLEAR_LOADING = 'CLEAR_LOADING';
export const BEGIN_LOADING = 'BEGIN_LOADING';

export const GET_CAROUSELS = 'GET_CAROUSELS';
export const GET_MEMBER_ACTIONS = 'GET_MEMBER_ACTIONS';
export const GET_MEMBER_ACTION_IS_READ = 'GET_MEMBER_ACTION_IS_READ';
export const UPDATE_MEMBER_ACTION_IS_READ = 'UPDATE_MEMBER_ACTION_IS_READ';

export const SEND_CODE = 'SEND_CODE';
export const SIGNUP_MEMBER = 'SIGNUP_MEMBER';
export const LOGIN_MEMBER = 'LOGIN_MEMBER';
export const SEND_CODE_LOGIN = 'SEND_CODE_LOGIN';
export const FORGET_PASSWORD = 'FORGET_PASSWORD';

export const GET_MEMBER = 'GET_MEMBER';
export const SEND_CODE_EMAIL = 'SEND_CODE_EMAIL';
export const CHANGE_EMAIL = 'CHANGE_EMAIL';
export const EMAIL_VERIFICATION = 'EMAIL_VERIFICATION';
export const SEND_CODE_MOBILE = 'SEND_CODE_MOBILE';
export const CHANGE_MOBILE = 'CHANGE_MOBILE';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';

export const GET_BINDINGS = 'GET_BINDINGS';
export const GET_BINDINGS_FAIL = 'GET_BINDINGS_FAIL';
export const GET_REVIEWS = 'GET_REVIEWS';
export const GET_DISPUTE = 'GET_DISPUTE';
export const APPLY_BINDING = 'APPLY_BINDING';
export const CANCEL_BINDING = 'CANCEL_BINDING';
export const GET_RETRIEVE_LAST = 'GET_RETRIEVE_LAST';
export const GET_BINDING = 'GET_BINDING';
export const RETRIEVE_ACCOUNT = 'RETRIEVE_ACCOUNT';

export const GET_ORDERS = 'GET_ORDERS';